function $cf838c15c8b009ba$export$2e2bcd8739ae039(event, selector, fn, context = document) {
    function handler(e) {
        const el = e.target.closest(selector);
        if (el) {
            const result = fn(e, el);
            if (result === false) e.preventDefault();
        }
    }
    context.addEventListener(event, (e)=>handler(e));
    return ()=>context.removeEventListener(event, handler);
}


export {$cf838c15c8b009ba$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=module.js.map
